// FAIXA DA BUSCA POR IA na listagem (INC-0018 F4): o que a IA avisou ("Não encontramos studio
// no Paraíso — mostrando os mais próximos (…)") e, quando o mesmo bairro existe em outras
// cidades do site, os links "Também em: Içara (12) · Tubarão (5)" para a MESMA busca lá.
// Os dados vêm do hero (utils/buscaIa → sessionStorage); sem aviso nem outras cidades, nada
// é renderizado. Cores do tenant (mesma régua da listagem) — funciona em fundo claro e escuro.
import Link from 'next/link';
import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { DadosFaixaBuscaIa, faixaTemConteudo } from '../../../utils/buscaIa';
import { hexToRgba, isColorLight } from '../../../utils/FunctionsGlobals';
import styles from './FaixaBuscaIa.module.css';

interface FaixaBuscaIaProps {
    site: any;
    dados: DadosFaixaBuscaIa | null;
    onFechar: () => void;
}

export default function FaixaBuscaIa({ site, dados, onFechar }: FaixaBuscaIaProps) {
    if (!dados || !faixaTemConteudo(dados)) return null;

    // Texto sobre o fundo do site (cor5) com a mesma escolha da listagem (`corLetra2`); a faixa é
    // só um véu de 8% da cor2 por cima desse fundo, então o contraste do texto se mantém.
    const corTexto = isColorLight(site?.cor5) ? site?.cor11 || '#111827' : site?.cor13 || '#ffffff';
    const corDestaque = site?.cor2 || corTexto;
    const variaveis = {
        '--faixa-ia-texto': corTexto,
        '--faixa-ia-destaque': corDestaque,
        '--faixa-ia-fundo': hexToRgba(corDestaque, 0.08),
        '--faixa-ia-borda': hexToRgba(corDestaque, 0.35),
    } as React.CSSProperties;

    // Sem aviso, só as outras cidades (ex.: "no centro" num site com várias cidades).
    const titulo = dados.aviso || (dados.lugar ? `${dados.lugar} de outra cidade?` : 'Procurando em outra cidade?');

    return (
        <div className={styles.faixa} style={variaveis} data-nosnippet>
            <svg
                className={styles.icone}
                width={18}
                height={18}
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
            >
                <path d="M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9L12 2z" />
                <path d="M19 14l0.9 2.6L22.5 17.5l-2.6 0.9L19 21l-0.9-2.6L15.5 17.5l2.6-0.9L19 14z" opacity="0.8" />
            </svg>
            <div className={styles.conteudo} role="status" aria-live="polite">
                <p className={styles.aviso}>{titulo}</p>
                {dados.outras_cidades.length > 0 ? (
                    <p className={styles.outras}>
                        <span className={styles.rotuloOutras}>Também em:</span>{' '}
                        {dados.outras_cidades.map((cidade, i) => (
                            <React.Fragment key={cidade.url}>
                                {i > 0 ? (
                                    <span className={styles.separador} aria-hidden="true">
                                        {' · '}
                                    </span>
                                ) : null}
                                <Link
                                    prefetch={false}
                                    href={cidade.url}
                                    className={styles.link}
                                    aria-label={`Ver a mesma busca em ${cidade.nome}${
                                        cidade.n > 0 ? ` (${cidade.n} ${cidade.n === 1 ? 'imóvel' : 'imóveis'})` : ''
                                    }`}
                                >
                                    {cidade.nome}
                                    {cidade.n > 0 ? ` (${cidade.n})` : ''}
                                </Link>
                            </React.Fragment>
                        ))}
                    </p>
                ) : null}
            </div>
            <button
                type="button"
                className={styles.fechar}
                onClick={onFechar}
                aria-label="Fechar aviso da busca"
                title="Fechar aviso"
            >
                <IoCloseSharp size={18} aria-hidden="true" />
            </button>
        </div>
    );
}
